import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient
  ) { }

  getNomineeDetails(clientId: any): Observable<any> {
    return this.http.get('/getNomineeDetails', { params: { clientcode: clientId } });
  }

  getNomineeData(clientId: any): Observable<any> {
    return this.http.get('/getNomineeData', { params: { clientcode: clientId } });
  }

  nomineeData(clientId: any): Observable<any> {
    return this.http.get('/nomineeData', { params: { clientcode: clientId } });
  }

  getAccountDetails(): Observable<any> {
    return this.http.get('/data');
  }

  getDpIdAndDematId(clientId: any): Observable<any> {
    return this.http.get('/getDpIdAndDematId', { params: { clientcode: clientId } });
  }

  onSubmitsendOtpForEmail(formData: any): Observable<any> {
    return this.http.post('/validateOtpEmail', formData);
  }

  onSubmitChangeEmail(formData: any): Observable<any> {
    return this.http.post('/changeEmail', formData);
  }

  onSubmitsendOtpForMobile(formData: any): Observable<any> {
    return this.http.post('/validateOtpMobile', formData);
  }

  onSubmitMobileChange(formData: any): Observable<any> {
    return this.http.post('/changeMobileNo', formData);
  }

  getBankDetails(ifscCode: any): Observable<any> {
    return this.http.get('/getBankDetails', { params: { ifsccode: ifscCode } });
  }

  getUserBankDetails(): Observable<any> {
    return this.http.get('/getAllBanks');
  }

  getUserBankStatus(): Observable<any> {
    return this.http.get('/getBankStatus');
  }

  insertBankdDetails(formData: any): Observable<any> {
    return this.http.post('/insertBankDetails', formData);
  }

  editBankdDetails(formData: any): Observable<any> {
    return this.http.post('/editBankIfsc', formData);
  }

  updateBankdDetails(formData: any): Observable<any> {
    return this.http.post('/updateBankDetail', formData);
  }

  insertNomineeDetails(formData: any): Observable<any> {
    return this.http.post('/nomineeDetails', formData);
  }

  updateNomineeDetails(formData: any): Observable<any> {
    return this.http.post('/nomineeDetailsUpdate', formData);
  }

  submitTPin(formData: any): Observable<any> {
    return this.http.post('/tpin', formData);
  }

  onSubmitnomineeOptOut(formData: any): Observable<any> {
    return this.http.post('/nomineeDetailsOptOut', formData);
  }

  //new bank modification API
  getBankList(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/bank-details/get-bank-list`);
  }

  checkIfscCode(ifscCode: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/bank-details/check-ifsc-code`, ifscCode);
  }

  createBank(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/bank-details/create-bank`, formData);
  }

  uploadBankProof(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/bank-details/upload-bank-proof`, formData);
  }

  //new Email and Mobile
  getClientPersonalDetail(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/client-modification/get-client-details`);
  }

  initiatePrevDetails(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/initiate-prev-verification`, formData);
  }

  generatePrevEmailMobileOtp(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/get-prev-otp`, formData);
  }

  validatePrevEmailMobileOtp(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/validate-prev-otp`, formData);
  }

  generateNewEmailOtp(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/email-modification`, formData);
  }

  generateNewMobileOtp(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/mobile-modification`, formData);
  }

  validateNewEmailMobileOtp(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/client-modification/otp-validation`, formData);
  }

  //new Nominee
  checkNomineeStatus(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/nominee/check-add-nominee-status`);
  }

  getNomineeSubmittedData(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/nominee/nominee-detail`);
  }

  checkNomineePincode(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/check-pincode`, formData);
  }

  checkNomineeDob(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/check-dob`, formData);
  }

  storeNomineeData(params: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/nominee-store`, params);
  }

  updateNomineeData(params: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/nominee-update`, params);
  }

  updateDigioEsign(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/update-digio-esign`, formData);
  }

  getEkycdpDetails(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/get-dp-ckyc-details`);
  }

  // segment
  getSegment(): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.get(`${baseUrl}/get-segment-status`);
  }

  getSegmentupdate(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/update-segment-status`, formData);
  }

  getVerifieddata(): Observable<any> {
    return this.http.get(`/verifiedPnlGet`, { responseType: 'text' });
  }

  getInstrument(): Observable<any> {
    const params = {
      segments: JSON.stringify(['mcx', 'fno', 'nse_com']),
    };
    return this.http.get(`/verifiedPnlInstruments`, { params });
  }

  getverifiedPnlCreate(params: any): Observable<any> {
    return this.http.get(`/verifiedPnlCreate`, { params });
  }

  getPnltransaction(params: any): Observable<any> {
    return this.http.get(`/verifiedPnl`, { params });
  }

  getpnldatetransaction(params: any): Observable<any> {
    return this.http.get(`/verifiedPnlDatewise`, { params });
  }

  // family
  getSubAccountDetails(): Observable<any> {
    return this.http.get('/familyList');
  }

  getSubAccount(params: any): Observable<any> {
    return this.http.get(`/familyList`, { params });
  }

  removeFamilyAccount(formData: any): Observable<any> {
    return this.http.post(`/familyCreate`, formData);
  }

  addFamilyAccount(formData: any): Observable<any> {
    return this.http.post(`/familyCreate`, formData);
  }

  showFamilyHoldings(formData: any): Observable<any> {
    return this.http.post(`/familyHoldings`, formData);
  }

  detailsFamily(params: any): Observable<any> {
    return this.http.get(`/family`, { params });
  }

  panDetails(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/validate-pan`, formData);
  }

  getotpoutout(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/nominee/validate-optout-otp`, formData);
  }

  // ddpi
  getpdf(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi-esign-pdf`, formData, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  getDdpieligible(): Observable<any> {
    return this.http.get('/ddpi-eligible');
  }

  getledgerbal(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi-ledger-balance `, formData);
  }

  getDigio(formData: any) {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi-amount-balance `, formData);
  }

  getDigioesign(formData: any) {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi-esign`, formData);
  }

  getDigiopdf(formData: any) {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi-esign-document`, formData);
  }

  getDigioStatus(formData: any): Observable<any> {
    const baseUrl = environment.apiBaseUrl;
    return this.http.post(`${baseUrl}/ddpi/client-stage`, formData);
  }

  getCmrGenerateDocument(params: any): Observable<any> {
    return this.http.get(`/cmrCopyGenerate`, { params: params });
  }

  // Referral changes

  getPartnerShiftingEligible(): Observable<any> {
    return this.http.get('/partnerShiftingEligible');
  }

  partnerShiftingPartnerDetails(params: any): Observable<any> {
    return this.http.get(`/partnerShiftingPartnerDetails`, { params: params });
  }

  partnerShiftingInitiatePayment(formData: any): Observable<any> {
    return this.http.post('/partnerShiftingInitiatePayment', formData);
  }

  partnerShiftingPaymentDetails(params: any): Observable<any> {
    return this.http.get(`/partnerShiftingPaymentDetails`, { params: params });
  }

  PartnerShiftingCancelPayment(formData: any): Observable<any> {
    return this.http.post('/partnerShiftingCancelPayment', formData);
  }

  // Client Remapping

  dekycShiftingEligible(): Observable<any> {
    return this.http.get('/dekycShiftingEligible');
  }

  dekycShiftingPartnerDetails(params: any): Observable<any> {
    return this.http.get(`/dekycShiftingPartnerDetails`, { params: params });
  }

  dekycShiftingSubmit(formData: any): Observable<any> {
    return this.http.post(`/dekycShiftingSubmit`, formData);
  }

  dekycShiftingAdminRedirection(): Observable<any> {
    return this.http.get(`/dekycShiftingAdminRedirection`, {});
  }

  // Address Modification
  generateDigioKid(): Observable<any> {
    return this.http.get(`/generate-digio-kid`);
  }

  getDigioResponse(): Observable<any> {
    return this.http.get(`/get-digio-response`);
  }

  verifyDetails(): Observable<any> {
    return this.http.get(`/addressModification`, {
      responseType: 'blob'
    });
  }

  uploadSignature(signature: string) {
    return this.http.post('/upload-signature',
      { signature },
      { responseType: 'blob' }
    );
  }

  setuEsignDetails() {
    return this.http.get(`/setu-esign-details`);
  }

  setuSignedPDF() {
    const payload = { setu_response: { message: 'Signed Successfully' } };
    return this.http.post('/setu-get-signed-pdf', payload);
  }

  checkAddressModificationStage() {
    return this.http.get(`/rekra-address-modification-stage`);
  }

}
